import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import DonutCard from 'components/DetailWidgets/DonutCard'
import SimpleDataTable from 'components/DetailWidgets/SimpleDataTable'

const STAT_ICONS = {
  device_types: UIcons.UilDesktop,
  top_device: UIcons.UilMobileAndroid,
  top_device_share: UIcons.UilPercentage,
  top_os: UIcons.UilAnalytics,
  avg_session_duration: UIcons.UilClockThree,
  avg_cost_per_device_view: UIcons.UilCreditCard
}

export default withTranslation()(function DevicesTab({ t, campaign }) {
  const { devices } = campaign

  const columns = [
    { key: 'device', label: t('rewardAds.detail.devices.table.device') },
    { key: 'viewers', label: t('rewardAds.detail.devices.table.viewers') },
    { key: 'completionRate', label: t('rewardAds.detail.devices.table.completion_rate') },
    { key: 'ctaClickRate', label: t('rewardAds.detail.devices.table.cta_click_rate') },
    { key: 'rewardClaims', label: t('rewardAds.detail.devices.table.reward_claims') }
  ]

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {
          devices.stats.map((stat) => (
            <StatCard
              key={stat.key}
              icon={STAT_ICONS[stat.key]}
              label={stat.label}
              value={stat.value}
              suffix={stat.suffix}
              trend={stat.trend}
              tone={stat.tone}
            />
          ))
        }
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <DonutCard title={t('rewardAds.detail.devices.device_breakdown')} data={devices.deviceBreakdown} />
        <DonutCard title={t('rewardAds.detail.devices.os_breakdown')} data={devices.osBreakdown} />
      </div>

      <SimpleDataTable columns={columns} rows={devices.deviceTable} />
    </div>
  )
})
